import { Component, OnInit } from '@angular/core';
import { RadnaKnjizica} from './radna-knjizica';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-radna-knjizica',
  templateUrl: './radna-knjizica.component.html',
})
export class RadnaKnjizicaComponent
 extends BaseModalContainer<RadnaKnjizica>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RadnaKnjizica>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
